import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as routeBound from '../../../route-bound'

import * as me from '../../../me'

import { Api } from './api.service'
import type { TypeParams } from './types'

/** TODO */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: idcCategory => idcCategory.id,
      name: ec.Name.Predefined.IdcFunctionCategory,
      plugins: {
        additionalFactories: [
          new ds.input.select.singleEc.ec.Factory({
            getItem: category => ({
              label: category.name,
              value: category.id,
            }),
          }),
          new ds.color.ec.Factory<TypeParams>(),
        ],
      },
    })
  }
}
